import { useDispatch } from "react-redux";
import { CHAT_BOT } from "../utils/constants";
import React, { useEffect, useRef, useState } from "react";
import { addBot } from "../store/configAppSlice";
import { toast, Bounce } from "react-toastify";
import Cookies from "js-cookie";
import { getChat } from "../Service/UserService";
import logo from "../image/Logo.png";
import ailogo from "../image/ai-chat-logo.png";
import peoplelogo from "../image/ai-people-logo.png";
import Slider from "react-slick";
import Typewriter from "typewriter-effect";

const Chatbot = () => {
  const input = useRef();
  const dispatch = useDispatch();
  const chatEndRef = useRef(null);
  const typewriterRef = useRef(null);

  const [messages, setMessages] = useState([
    { sender: "ChatBot", text: "Namaste! How can I help you today?" },
  ]);
  const [suggestions, setSuggestions] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [currentTypewriter, setCurrentTypewriter] = useState(null);

  const handleBot = () => dispatch(addBot());

  const handleStopTyping = () => {
    if (currentTypewriter) {
      currentTypewriter.stop();
      setIsTyping(false);
      setMessages((prev) =>
        prev.map((msg) =>
          msg.isThinking ? { ...msg, text: "Stopped", isThinking: false } : msg
        )
      );
    }
  };

  const handleSearch = async (query) => {
    if (!query.trim()) return;

    // Stop any ongoing response
    handleStopTyping();

    // Show user message & add "Thinking..." message from ChatBot
    setMessages((prev) => [
      ...prev,
      { sender: "User", text: query },
      { sender: "ChatBot", text: "Thinking...", isThinking: true },
    ]);
    setIsTyping(true);

    try {
      const token = Cookies.get("access_token");
      if (!token) {
        toast.error("Unauthorized: Token missing", {
          theme: "dark",
          transition: Bounce,
        });
        return;
      }

      const response = await getChat(
        { question: query.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response?.answer) {
        setMessages((prev) => {
          const updatedMessages = prev.filter((msg) => !msg.isThinking);
          return [
            ...updatedMessages,
            {
              sender: "ChatBot",
              text: response.answer.replace(/\n/g, "<br/>"),
            },
          ];
        });

        setSuggestions(response?.suggestions || []);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        theme: "dark",
        transition: Bounce,
      });

      setMessages((prev) => {
        const updatedMessages = prev.filter((msg) => !msg.isThinking);
        return [
          ...updatedMessages,
          { sender: "ChatBot", text: "Error occurred." },
        ];
      });
    }

    input.current.value = "";
  };

  useEffect(
    () => chatEndRef.current?.scrollIntoView({ behavior: "smooth" }),
    [messages]
  );

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: true,
  };

  return (
    <div className="fixed w-full left-0 top-0 z-20 h-screen rounded-xl flex flex-col items-center bg-zinc-950 bg-opacity-85">
      <div className="relative lg:w-[70%] pt-28 w-full rounded-xl overflow-hidden">
        <div className="w-full flex justify-between rounded-t-xl items-center bg-purple-700 py-4 px-4">
          <div className="flex items-center">
            <img className="w-10 lg:w-14" src={logo} alt="logo" />
            <span className="text-2xl text-purple-200 font-semibold uppercase">
              {CHAT_BOT}
            </span>
          </div>
          <i
            className="text-3xl text-purple-300 ri-close-fill cursor-pointer"
            onClick={handleBot}
          ></i>
        </div>

        <div className="overflow-y-scroll px-4 py-3 h-[65vh] bg-purple-950 relative">
          {messages.map((message, index) => {
            const isUserMessage = message.sender === "User";
            return (
              <div
                key={index}
                className={`flex ${
                  isUserMessage ? "justify-end" : "justify-start"
                } mb-4`}
              >
                {!isUserMessage && (
                  <img src={ailogo} className="w-10 h-10 rounded-full mr-2" />
                )}
                <div
                  className={`${
                    isUserMessage ? "bg-purple-800 text-right" : "bg-purple-600"
                  } px-3 py-1.5 rounded-lg text-white font-medium`}
                >
                  {isUserMessage ? (
                    message.text
                  ) : message.isThinking ? (
                    <span className="animate-pulse">Thinking...</span>
                  ) : (
                    <Typewriter
                      options={{
                        autoStart: true,
                        delay: 5,
                        cursor: "",
                        wrapperClassName: "typewriter",
                      }}
                      onInit={(typewriter) => {
                        setCurrentTypewriter(typewriter);
                        typewriterRef.current = typewriter;
                        typewriter
                          .typeString(message.text.replace(/\n/g, "<br/>"))
                          .start()
                          .callFunction(() => setIsTyping(false));
                      }}
                    />
                  )}
                </div>
                {isUserMessage && (
                  <img src={peoplelogo} className="w-8 h-8 rounded-full ml-2" />
                )}
              </div>
            );
          })}
          <div ref={chatEndRef} />

          
        </div>
        {/* Suggestions */}
          {/* Suggestions Box */}
          <div className="sticky bottom-0 left-0 w-full bg-purple-950 p-2 z-10">
            {suggestions.length > 0 && (
              <Slider {...sliderSettings} className="flex gap-2 mx-5">
                {suggestions.map((suggestion, index) => (
                  <div key={index} className="whitespace-nowrap px-1">
                    <button
                      className="bg-purple-500 text-white px-3 py-1 rounded-md hover:bg-purple-600"
                      onClick={() => {
                        handleStopTyping();
                        handleSearch(suggestion);
                      }}
                    >
                      {suggestion}
                    </button>
                  </div>
                ))}
              </Slider>
            )}
          </div>

        <div className="flex justify-center bg-purple-700 items-center px-4 w-full py-2">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="w-full relative flex"
          >
            <input
              className="w-full py-2 px-5 rounded-full outline-none placeholder-gray-700"
              type="text"
              placeholder="Ask anything"
              ref={input}
              disabled={isTyping}
            />
            {!isTyping ? (
              <button
                className="px-4 py-1 absolute right-0 bg-purple-500"
                onClick={() => handleSearch(input.current.value)}
              >
                <i className="text-2xl ri-send-plane-2-fill"></i>
              </button>
            ) : (
              <button
                className="ml-3 text-white bg-red-600 px-3 py-2 rounded-full"
                onClick={handleStopTyping}
              >
                <i className="text-xl ri-stop-fill"></i>
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
